const Button = ({bgClass, text, onClick}) => {

    return(
        <button className={`${bgClass}  text-white rounded px-20 py-3 text-2xl  uppercase   `} onClick={onClick}>
            {text}
        </button>
    )
}

export default Button;